"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialShare = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var social_service_1 = require("../../../services/social.service");
var CopyButton_1 = require("./CopyButton");
var SocialButton_1 = require("./SocialButton");
require("./styles.less");
exports.SocialShare = function (_a) {
    var shareText = _a.shareText, onSocialShare = _a.onSocialShare, height = _a.height, width = _a.width;
    return (
    // TODO rename class to c-social-share when can.js component is deleted
    react_1.default.createElement("div", { className: "c-social-share-react" },
        react_1.default.createElement("span", { className: "c-social-share__text" }, "Share"),
        react_1.default.createElement(SocialButton_1.SocialButton, { height: height, width: width, network: social_service_1.SocialNetworks.FACEBOOK, onSocialShare: onSocialShare }),
        react_1.default.createElement(SocialButton_1.SocialButton, { height: height, width: width, network: social_service_1.SocialNetworks.TWITTER, onSocialShare: onSocialShare, shareText: shareText }),
        react_1.default.createElement(SocialButton_1.SocialButton, { height: height, width: width, network: social_service_1.SocialNetworks.LINKEDIN, onSocialShare: onSocialShare }),
        react_1.default.createElement(SocialButton_1.SocialButton, { height: height, width: width, network: social_service_1.SocialNetworks.EMAIL, onSocialShare: onSocialShare }),
        react_1.default.createElement(CopyButton_1.CopyButton, { height: height, width: width })));
};
